import { CheckBox } from 'grommet'

export default CheckBox
